/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  Button,
  SvgIcon,
  TextArea,
  Modal,
  ExpandableOverviewItem
} from '../'


export class RequestValidate extends React.PureComponent {
  static propTypes = {
    requestRun: PropTypes.shape({
      id: PropTypes.string,
      sources: PropTypes.array,
      requesttype: PropTypes.object,
      notes: PropTypes.string,
      capturedBy: PropTypes.object,
      validatedBy: PropTypes.object,
      isValidated: PropTypes.bool
    }),
    open: PropTypes.bool,
    updateRequestRun: PropTypes.func.isRequired,
    locked: PropTypes.bool,
    toggleOpen: PropTypes.func.isRequired,
    userIsContentCaptor: PropTypes.bool,
    onValidated: PropTypes.func,
    onRejected: PropTypes.func.isRequired,
    singleItemCondensedView: PropTypes.bool,
    className: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      notes: props.requestRun.notes || ''
    }
  }

  handleRejectClick = () => this.setState({ showNotesModal: true })

  handleValidateClick = () => {
    this.props.updateRequestRun({
      id: this.props.requestRun.id,
      validatedBy: localStorage.getItem('userNodeId'),
      validatedAt: moment.utc().toISOString()
    })
    .then(() => {
      console.log('request run validation successful')
      this.props.onValidated()
    })
    .catch(error => console.log('Failed to update/validate request run', error))
  }

  handleSaveNotesClick = () => {
    if (this.state.notes !== this.props.requestRun.notes) {
      this.props.updateRequestRun({
        id: this.props.requestRun.id,
        notes: this.state.notes
      })
      .then(() => {
        console.log('request run notes save successful')
        this.props.onRejected()
      })
      .catch(error => console.log('Failed to update request run notes', error))
    } else {
      this.props.onRejected()
    }
  }

  render() {
    let { requestRun, open, locked, userIsContentCaptor, toggleOpen, singleItemCondensedView, className } = this.props
    let isValidated = requestRun.isValidated

    return (
      <ExpandableOverviewItem
        title='Validate'
        iconSymbol={isValidated
          ? 'check'
          : requestRun.isCaptured ? 'warning' : null}
        iconColour={isValidated
          ? 'success'
          : 'warning'
        }
        open={open}
        locked={locked || userIsContentCaptor || !requestRun.isCaptured || isValidated}
        onClick={toggleOpen}
        summary={requestRun.validatedBy
          ? `${requestRun.validatedBy.firstName} ${requestRun.validatedBy.lastName}`
          : requestRun.notes
        }
        singleItemCondensedView={singleItemCondensedView}
        className={className}>
        {requestRun.notes && requestRun.notes.length > 0 &&
          <TextArea
            label='Notes'
            value={requestRun.notes}
            disabled={true}
            rows={5}
          />
        }
        {this.props.requestRun.status !== 'ON_HOLD' &&
          <div id='rejectOrValidate' className='slds-m-left_large slds-m-bottom_large'>
            <Button
              type='brand'
              onClick={this.handleRejectClick}
              minWidth={150}
              disabled={userIsContentCaptor}>
              <SvgIcon
                variant='utility'
                symbol='close'
                colour='inverse'
                size='x-small'
                buttonIcon={true}
                className='slds-button__icon_left'
              />
              Reject
            </Button>
            <Button
              type='brand'
              onClick={this.handleValidateClick}
              minWidth={150}
              disabled={userIsContentCaptor}>
              <SvgIcon
                variant='utility'
                symbol='check'
                colour='inverse'
                size='x-small'
                buttonIcon={true}
                className='slds-button__icon_left'
              />
              Validate
            </Button>
          </div>
        }
        {this.state.showNotesModal &&
          <Modal
            body={
              <div className='slds-text-align_center'>
                <TextArea
                  label='Please add a note'
                  value={this.state.notes}
                  onChange={e => this.setState({ notes: e.target.value })}
                  rows={5}
                />
                <div className='slds-m-top_medium'>
                  <Button
                    minWidth={140}
                    onClick={() => {
                      this.setState({ notes: '', showNotesModal: false })
                    }}>
                    Cancel
                  </Button>
                  <Button
                    type='brand'
                    minWidth={140}
                    onClick={() => {
                      this.handleSaveNotesClick()
                      this.setState({ showNotesModal: false })
                      toggleOpen()
                    }}>
                    Save
                  </Button>
                </div>
              </div>
            }
            elementId='rejectOrValidate'
          />
        }
      </ExpandableOverviewItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/request-validate/index.js